import React, { useState } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'
import LogoIcon from '../../assets/img/curvo-logo.png'
import { Flex } from '../../shared/components/Flex'
import PageLayout from '../../shared/components/PageLayout'
import { SearchTypeEnum } from '../../api'
import AdvanceSearch from './AdvanceSearch'
import RecentFiles from './RecentFiles'
import RecentSearch from './RecentSearch'
import SearchGroup from './SearchGroup'
import SearchModeTab from './SearchModeTab'

const Wrapper = styled(Flex)`
  width: 70vw;
  margin: 0 auto;

  @media (max-width: 1024px) {
    width: 80vw;
  }
  @media (max-width: 768px) {
    width: 90vw;
  }
`
const LogoContainer = styled(Flex)`
  gap: 2rem;
  align-items: flex-end;
`

const LogoWrapper = styled.div<{ $active?: boolean }>`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  filter: ${props => (props.$active ? 'none' : 'grayscale(100%)')};
  opacity: ${props => (props.$active ? 1 : 0.5)};

  &:hover {
    opacity: ${props => (props.$active ? 1 : 0.7)};
  }
`

const LogoBlock = styled.div`
  width: 350px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`

const FormerLookupTagline = styled.small`
  display: block;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.875rem;
  font-style: italic;
  color: #6b7280;
  text-align: right;
`

type Props = {} & RouteComponentProps<{}, {}, { searchMode: SearchTypeEnum }>

const Home: React.FC<Props> = ({ location }) => {
  const [searchType, setSearchType] = useState<SearchTypeEnum>(
    location.state ? location.state.searchMode : SearchTypeEnum.Part,
  )
  return (
    <PageLayout isHomePage>
      <Wrapper column align="center">
        <LogoContainer marginTop="3rem">
          <LogoBlock>
            <LogoWrapper $active>
              <img src={LogoIcon} alt="Curvo Labs Logo" width="350" />
            </LogoWrapper>
            <FormerLookupTagline>formerly known as Lookup</FormerLookupTagline>
          </LogoBlock>
        </LogoContainer>
        <Flex fullWidth marginTop="2rem" marginBottom="0.75rem">
          <SearchModeTab searchType={searchType} setSearchType={setSearchType} />
        </Flex>
        {searchType !== SearchTypeEnum.Advanced && (
          <>
            <SearchGroup searchType={searchType} isHomePage />
            <Flex fullWidth marginTop="3rem">
              <RecentSearch />
            </Flex>
            <Flex fullWidth marginTop="3rem">
              <RecentFiles />
            </Flex>
          </>
        )}
        {searchType === SearchTypeEnum.Advanced && <AdvanceSearch />}
      </Wrapper>
    </PageLayout>
  )
}

export default withRouter(Home)
